import React from "react";
import { SelectUploadImageContextType } from "./types";

export const SelectUploadImageContext = React.createContext<
  SelectUploadImageContextType | undefined
>(undefined);
